import React from 'react';
import { connect } from 'dva';

import Document, { DocumentProps } from '../../shared/Document/Document';
import {
  childHasActivePassport,
  getActiveChildPassport,
} from '../../../selectors/child';
import { isForeignCitizen } from '../../../helpers/isForeignCitizen';
import { CHILD } from '../../../models/child';
import ChildDocumentWarning from './ChildDocumentWarning';

type Props = DocumentProps & { shouldShowSecondDocument: boolean };

function ChildDocument(props: Props): JSX.Element | null {
  if (!props.shouldShowSecondDocument) return null;

  return (
    <div className="Document">
      <Document {...props} model={CHILD} />
      <ChildDocumentWarning />
    </div>
  );
}

function mapStateToProps(state) {
  const {
    child: { citizenship, birthdate, birthPlace },
  } = state;

  return {
    ...getActiveChildPassport(state),
    citizenship: citizenship.value,
    showBirthPlace: true,
    birthPlace,
    shouldShowSecondDocument:
      isForeignCitizen(citizenship.value) || childHasActivePassport(state),
  };
}

export default connect(mapStateToProps)(ChildDocument);
